module.exports = __webpack_public_path__ + "static/media/storie-ig-calendar.9839ebf4.svg";